import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Houston = () => {
  useEffect(() => {
    // Update page title and meta tags
    document.title = 'We Buy Valves Houston | Industrial Equipment Buyers Houston TX';
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Houston - Leading valve buyers in Houston, TX. We purchase surplus valves, Fisher control valves, and instrumentation from Houston refineries and petrochemical plants. Fast quotes and top pricing.');
    }
    
    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'Houston valve buyers, Houston industrial equipment, Fisher valves Houston, surplus equipment Houston TX, refinery equipment buyers Houston');
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/houston');
    
    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Houston Valve Buyers | ValveSalesSupply' },
      { property: 'og:description', content: 'Leading valve buyers in Houston, TX. We purchase surplus valves, Fisher control valves, and instrumentation from Houston refineries and petrochemical plants.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/houston' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Geo tags for Houston
    const geoTags = [
      { name: 'geo.position', content: '29.7604;-95.3698' },
      { name: 'geo.placename', content: 'Houston, Texas' },
      { name: 'geo.region', content: 'US-TX' }
    ];
    
    geoTags.forEach(tag => {
      let geoTag = document.querySelector(`meta[name="${tag.name}"]`);
      if (!geoTag) {
        geoTag = document.createElement('meta');
        geoTag.setAttribute('name', tag.name);
        document.head.appendChild(geoTag);
      }
      geoTag.setAttribute('content', tag.content);
    });
    
    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/houston/#webpage",
          "url": "https://valvesalessupply.com/houston",
          "name": "Houston Valve Buyers - ValveSalesSupply Houston TX",
          "description": "Leading valve buyers in Houston, TX. We purchase surplus valves, Fisher control valves, and instrumentation from Houston refineries and petrochemical plants. Fast quotes and top pricing.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Texas",
                "item": "https://valvesalessupply.com/texas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Houston",
                "item": "https://valvesalessupply.com/houston"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/houston/#place",
          "name": "Houston, Texas",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Houston",
            "addressRegion": "TX",
            "addressCountry": "US",
            "postalCode": "77002"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 29.7604,
            "longitude": -95.3698
          },
          "description": "Energy capital of the world with the largest concentration of refineries and petrochemical plants in North America"
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Houston Operations",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Houston",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "telephone": "+1-214-854-5638",
          "email": "houston@valvesalessupply.com",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 29.7604,
            "longitude": -95.3698
          },
          "serviceArea": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 29.7604,
              "longitude": -95.3698
            },
            "geoRadius": "100 mi"
          },
          "description": "Professional industrial equipment purchasing services in Houston, specializing in surplus valves, control valves, and instrumentation from refineries and petrochemical facilities.",
          "knowsAbout": [
            "Refinery Equipment Valuation",
            "Fisher Control Valves",
            "Petrochemical Operations",
            "Industrial Valve Assessment",
            "Process Instrumentation"
          ],
          "areaServed": [
            "Houston",
            "Pasadena",
            "Baytown",
            "Texas City",
            "Deer Park",
            "La Porte",
            "Channelview"
          ]
        },
        {
          "@type": "Service",
          "name": "Houston Industrial Equipment Purchasing",
          "description": "Specialized purchasing of surplus industrial equipment from Houston-area refineries and petrochemical plants including valves, instrumentation, and control systems",
          "provider": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "areaServed": {
            "@type": "Place",
            "name": "Houston, Texas",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Houston",
              "addressRegion": "TX",
              "addressCountry": "US"
            }
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Do you buy valves from Houston refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Houston-area refineries including ExxonMobil Baytown, Shell Deer Park, Marathon Galveston Bay, and all Gulf Coast facilities. We provide fast 4-6 hour response times and competitive pricing for Houston operations."
              }
            },
            {
              "@type": "Question",
              "name": "What types of equipment do you buy in Houston?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all types of industrial equipment from Houston facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from refineries and petrochemical plants."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond to Houston facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide 4-6 hour response times for Houston and Gulf Coast facilities. Our local Houston team has extensive refinery experience and can quickly evaluate your surplus equipment, provide competitive quotes, and arrange pickup to meet your turnaround schedules."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy equipment from ExxonMobil and Shell refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We regularly purchase surplus equipment from ExxonMobil Baytown, Shell Deer Park, Marathon Galveston Bay, Valero Houston, and all major Houston-area refineries. We understand the specific equipment used in refinery operations and provide expert valuations."
              }
            },
            {
              "@type": "Question",
              "name": "What brands of valves do you buy in Houston?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Houston refineries and petrochemical plants."
              }
            },
            {
              "@type": "Question",
              "name": "Can you handle large equipment removals from Houston refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We have the equipment, expertise, and logistics capabilities to handle large-scale equipment removals from Houston-area refineries and petrochemical plants. We coordinate all aspects including disconnection, rigging, transportation, and site cleanup while maintaining full safety compliance."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const houstonRefineries = [
    { name: 'ExxonMobil Baytown', location: 'Baytown', capacity: '584,000 bpd' },
    { name: 'Shell Deer Park', location: 'Deer Park', capacity: '340,000 bpd' },
    { name: 'Marathon Galveston Bay', location: 'Texas City', capacity: '593,000 bpd' },
    { name: 'Valero Houston', location: 'Houston', capacity: '145,000 bpd' },
    { name: 'LyondellBasell Houston', location: 'Houston', capacity: '302,000 bpd' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Houston refineries?",
      answer: "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Houston-area refineries including ExxonMobil Baytown, Shell Deer Park, Marathon Galveston Bay, and all Gulf Coast facilities. We provide fast 4-6 hour response times and competitive pricing for Houston operations."
    },
    {
      question: "What types of equipment do you buy in Houston?",
      answer: "We purchase all types of industrial equipment from Houston facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from refineries and petrochemical plants."
    },
    {
      question: "How quickly can you respond to Houston facilities?",
      answer: "We provide 4-6 hour response times for Houston and Gulf Coast facilities. Our local Houston team has extensive refinery experience and can quickly evaluate your surplus equipment, provide competitive quotes, and arrange pickup to meet your turnaround schedules."
    },
    {
      question: "Do you buy equipment from ExxonMobil and Shell refineries?",
      answer: "Absolutely! We regularly purchase surplus equipment from ExxonMobil Baytown, Shell Deer Park, Marathon Galveston Bay, Valero Houston, and all major Houston-area refineries. We understand the specific equipment used in refinery operations and provide expert valuations."
    },
    {
      question: "What brands of valves do you buy in Houston?",
      answer: "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Houston refineries and petrochemical plants."
    },
    {
      question: "Can you handle large equipment removals from Houston refineries?",
      answer: "Yes! We have the equipment, expertise, and logistics capabilities to handle large-scale equipment removals from Houston-area refineries and petrochemical plants. We coordinate all aspects including disconnection, rigging, transportation, and site cleanup while maintaining full safety compliance."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 text-teal-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-map-pin-line"></i>
              <span>Serving Houston & Surrounding Areas</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              We Buy Valves Houston
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Houston's trusted buyer of used valves, instrumentation, and process equipment. 
              Fast quotes, competitive prices, and immediate pickup available.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="tel:2148545638"
                className="inline-flex items-center gap-2 bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Call (214) 854-5638
              </a>
              <a
                href="mailto:valvesalessupply@gmail.com"
                className="inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl"></i>
                Get a Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Brands We Buy in Houston */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Premium Equipment Brands We Buy in Houston
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality used industrial equipment from leading manufacturers. 
              Serving Houston refineries, chemical plants, and industrial facilities.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {/* Valves & Controls */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-settings-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Valves & Controls</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Fisher Valves Houston</strong> - Control valves, regulators, actuators</p>
                <p className="text-gray-700"><strong>Masoneilan Equipment</strong> - Control valves, positioners</p>
                <p className="text-gray-700"><strong>Valtek Valves</strong> - Severe service valves</p>
                <p className="text-gray-700"><strong>Q-Check Valves</strong> - Check valves, ball valves</p>
                <p className="text-gray-700"><strong>WKM Valves</strong> - Gate valves, ball valves</p>
                <p className="text-gray-700">Flowseal, Centerline, Relief Valves, General Twinseal, Tufline, Orbit, Durco, Edwards</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Your Valves <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Instrumentation */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-dashboard-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Instrumentation</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Rosemount Transmitters Houston</strong> - Pressure, temperature, flow transmitters</p>
                <p className="text-gray-700"><strong>Foxboro Instrumentation</strong> - Transmitters, controllers, recorders</p>
                <p className="text-gray-700"><strong>Fisher Instruments</strong> - Controllers, recorders, transmitters</p>
                <p className="text-gray-700"><strong>Barton Instruments</strong> - Differential pressure instruments</p>
                <p className="text-gray-700">Taylor Transmitters</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Your Instruments <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Actuators & Positioners */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-cpu-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Actuators & Positioners</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Fisher Actuators Houston</strong> - Pneumatic, electric actuators</p>
                <p className="text-gray-700"><strong>Limitorque Actuators</strong> - Electric valve actuators</p>
                <p className="text-gray-700"><strong>Bettis Actuators</strong> - Pneumatic, hydraulic actuators</p>
                <p className="text-gray-700"><strong>Fisher Positioners</strong> - Valve positioners</p>
                <p className="text-gray-700">Foxboro Positioners, Masoneilan, Valtek</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Your Actuators <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Flow Measurement */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-water-flash-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Flow Measurement</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Badger Water Meters Houston</strong> - Industrial water meters</p>
                <p className="text-gray-700"><strong>Rockwell Meters</strong> - Flow measurement devices</p>
                <p className="text-gray-700"><strong>Neptune Meters</strong> - Water meters, flow meters</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Your Meters <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Fittings & Connections */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-plug-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Fittings & Connections</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Parker Fittings Houston</strong> - Tube fittings, adapters</p>
                <p className="text-gray-700"><strong>Swagelok Fittings</strong> - Tube fittings, valves, manifolds</p>
                <p className="text-gray-700"><strong>Anderson Greenwood</strong> - Manifolds, fittings</p>
                <p className="text-gray-700"><strong>Hoke Fittings</strong> - High-pressure fittings</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Your Fittings <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Temperature & Gauges */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-temp-hot-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Temperature & Gauges</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>WIKA Gauges Houston</strong> - Pressure gauges, thermometers</p>
                <p className="text-gray-700"><strong>All Temp Sensors</strong> - RTDs, thermocouples</p>
                <p className="text-gray-700"><strong>OCI Thermowells</strong> - Temperature sensors</p>
                <p className="text-gray-700"><strong>MCDaniel Gauges</strong> - Industrial gauges</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Your Gauges <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">Have Equipment from These Brands?</h3>
            <p className="text-lg mb-6 opacity-90">
              We buy used, surplus, and excess inventory from Houston's industrial facilities. 
              Get a competitive quote today!
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="tel:2148545638"
                className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                (214) 854-5638
              </a>
              <a
                href="mailto:valvesalessupply@gmail.com"
                className="inline-flex items-center gap-2 bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                Email for Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Houston Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">HOUSTON VALVE BUYERS - ENERGY CAPITAL EXPERTS</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Houston is the energy capital of the world with the largest concentration of refineries 
                in North America. As experienced <strong className="text-[#1B3A5F]">Houston valve buyers</strong> and 
                <strong className="text-[#1B3A5F]"> Gulf Coast equipment buyers</strong>, we specialize in 
                purchasing surplus equipment from refineries and petrochemical plants.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We buy <strong className="text-[#1B3A5F]">Fisher control valves Houston</strong>, 
                surplus gate valves, Rosemount transmitters, and refinery equipment from 
                ExxonMobil, Shell, Marathon, and all Houston-area facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">50+</div>
                  <div className="text-gray-600">Refineries</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">4-6 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">24/7</div>
                  <div className="text-gray-600">Service</div>
                </div>
              </div>

              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Related Texas Markets:</h4>
                <div className="flex flex-wrap gap-2">
                  <Link to="/beaumont" className="text-[#1B3A5F] hover:underline">Beaumont</Link>
                  <span className="text-gray-400">•</span>
                  <Link to="/corpus-christi" className="text-[#1B3A5F] hover:underline">Corpus Christi</Link>
                  <span className="text-gray-400">•</span>
                  <Link to="/texas" className="text-[#1B3A5F] hover:underline">All Texas Cities</Link>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">MAJOR HOUSTON REFINERIES</h3>
              <div className="space-y-4">
                {houstonRefineries.map((refinery, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{refinery.name}</h4>
                      <p className="text-gray-600 text-sm">{refinery.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">{refinery.capacity}</div>
                      <div className="text-gray-600 text-sm">Capacity</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES HOUSTON - WE PAY TOP DOLLAR</h2>
            <p className="text-gray-600 text-xl">Professional equipment buyers serving the Energy Capital</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                category: 'Refinery Valves Houston',
                brands: ['Fisher', 'Masoneilan', 'Flowserve', 'Cameron'],
                types: ['Control Valves', 'Gate Valves', 'Globe Valves', 'Check Valves']
              },
              {
                category: 'Process Instrumentation',
                brands: ['Rosemount', 'Emerson', 'Honeywell', 'ABB'],
                types: ['Transmitters', 'Controllers', 'Analyzers', 'Flow Meters']
              },
              {
                category: 'Safety Systems Houston',
                brands: ['Anderson Greenwood', 'Crosby', 'Consolidated', 'Farris'],
                types: ['Relief Valves', 'Safety Valves', 'Rupture Discs', 'Regulators']
              }
            ].map((equipment, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">{equipment.category}</h3>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands We Buy:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 className="text-gray-800 font-bold mb-3">Equipment Types:</h4>
                  <div className="space-y-2">
                    {equipment.types.map((type, typeIndex) => (
                      <div key={typeIndex} className="flex items-center">
                        <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                        <span className="text-gray-600">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves (City) */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES HOUSTON</h2>
            <p className="text-gray-600 text-xl">Houston's premier surplus valve buyers - serving the Energy Capital</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">HOUSTON SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">Houston's leading surplus valve buyers</strong>, we 
                specialize in purchasing high-quality used valves from the world's largest refining complex. 
                Our deep understanding of refinery operations and valve specifications ensures you receive 
                maximum value for your surplus valve inventory.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Refinery Control Valves',
                    description: 'Fisher DVC6000, 667, 657 - ExxonMobil, Shell, Marathon specifications',
                    count: '500+ Units',
                    icon: 'ri-settings-4-line'
                  },
                  {
                    type: 'Gate & Globe Valves',
                    description: 'API 6D, ANSI Class 150-2500 from major Houston refineries',
                    count: '1000+ Units',
                    icon: 'ri-stop-circle-line'
                  },
                  {
                    type: 'Safety Relief Valves',
                    description: 'Anderson Greenwood, Crosby from petrochemical plants',
                    count: '300+ Units',
                    icon: 'ri-shield-check-line'
                  },
                  {
                    type: 'Ball & Check Valves',
                    description: 'Trunnion mounted, floating ball from Gulf Coast facilities',
                    count: '200+ Units',
                    icon: 'ri-checkbox-circle-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="bg-[#F5F7FA] rounded-lg p-4">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4">
                        <i className={`${valve.icon} text-white text-xl`}></i>
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="text-[#1B3A5F] font-bold text-lg">{valve.type}</h4>
                          <span className="text-[#1B3A5F] text-sm font-semibold">{valve.count}</span>
                        </div>
                        <p className="text-gray-600 text-sm">{valve.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-gradient-to-r from-[#1B3A5F] to-[#2B5F8F] rounded-lg p-6 text-white">
                <h4 className="font-bold mb-3">Houston Advantage:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-time-line mr-3"></i>
                    <span>4-6 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line mr-3"></i>
                    <span>Highest Houston prices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line mr-3"></i>
                    <span>Gulf Coast logistics</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line mr-3"></i>
                    <span>Refinery expertise</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/6eb475f0d8beea92fcabf40d30be69fe.jpg')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Houston Refinery Grade Valves</h3>
                  <p>Premium surplus valves from the world's largest refining complex</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">HOUSTON VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment in Houston</p>
          </div>
          
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-600 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">HOUSTON VALVE BUYERS - CALL TODAY</h2>
            <p className="text-gray-200 text-xl">Fast quotes for Gulf Coast equipment</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">HOUSTON LOCAL OFFICE</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">214-854-5638</div>
                    <div className="text-gray-600">Houston Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">houston@valvesalessupply.com</div>
                    <div className="text-gray-600">Equipment Lists & Photos</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">4-6 Hour Response</div>
                    <div className="text-gray-600">Gulf Coast Coverage</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Gulf Coast Manager</h4>
                <p className="text-gray-600">Mark Driver - Refinery specialist</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">HOUSTON ADVANTAGE</h3>
              <div className="space-y-4">
                {[
                  'Highest valve prices in Houston',
                  'Fastest 4-6 hour response times',
                  'Expert refinery experience',
                  'Complete regulatory compliance',
                  'Local Houston team with refinery knowledge',
                  'Turnaround scheduling expertise'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <a
                  href="tel:214-854-5638"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  CALL: 214-854-5638
                  <i className="ri-phone-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Houston;
